import {autoserialize} from 'cerialize';

export default class File {
    @autoserialize public filename: string;
    @autoserialize public parent_folder_id: number;
    @autoserialize public id: number;
    @autoserialize public subject: string;
    @autoserialize public size: number;
    @autoserialize public modified_at: string;
    @autoserialize public url: string;

    constructor(filename: string,
                parent_folder_id: number,
                id: number,
                subject: string,
                size: number,
                modified_at: string,
                url: string) {

        this.filename = filename;
        this.parent_folder_id = parent_folder_id;
        this.id = id;
        this.subject = subject;
        this.size = size;
        this.modified_at = modified_at;
        this.url = url;
    }
}